<router-outlet></router-outlet>

<ngx-spinner
  bdColor="rgba(0,0,0,0.8)"
  size="medium"
  [color]="_persona.colorPrimary.a600"
  type="ball-fussion"
  [fullScreen]="true"
>
  <p [style.color]="_persona.colorPrimary.a600">{{ 'loading' | transloco }} ...</p>
</ngx-spinner>
